<template>
      <div class="content-wrapper">
         <div class="page-content fade-in-up">
                        <div class="ibox">
                            <div class="ibox-body">
                                    <div class="row">
                                        <div class="col-md-2">
                                                <div class="gallery">
                                                    <div class="image-wrapper"
                                                        @click="$refs.logoInput.click()">
                                                        <a target="_blank" @mouseover="showToolTip=true"
                                                                        @mouseleave="showToolTip=false">
                                                        <img :src="application.logo.image" 
                                                            width="600"
                                                            height="400">
                                                        </a>

                                                        <input type="file"
                                                               style="display:none"
                                                               @input="addLogo"
                                                               id="logoInput"
                                                               ref="logoInput">               
                                                    </div>
                                                </div>
                                                
                                        </div>
                                        <span class="tooltiptextlogo" 
                                                v-bind:class="{ tooltiptextvisible : showToolTip }"> {{$t('message.addUpdateAppLogo')}} </span>
                                                                        
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                            <div class="col-md-3">
                                                    <label>{{$t('message.addUpdateTabText')}}:</label>
                                                            <input v-model="application.tab_text"
                                                                style="width:300px"
                                                                type="text"
                                                                class="form-control"
                                                                :placeholder="$t('message.addUpdateTabText')">
                                            </div>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                            <div class="col-md-3">
                                                    <label>{{$t('message.dashboardVisibleForCraftsmen')}}:</label><br>
                                                             <label class="switch">
                                                                <input type="checkbox" v-model="application.dashboard_visible_craftsmen" @change="updateApplicationDetails">
                                                                <span class="slider"></span>
                                                            </label>
                                            </div>
                                    </div>
                                  
                                    <div class="row" style="margin-top: 20px; ">
                                                    <div class="col-md-12 text-center">
                                                        <button @click="updateApplicationDetails" style="margin: 1%;"
                                                                class="btn btn-primary">
                                                            {{$t('message.update')}}
                                                        </button>
                                                    </div>
                                    </div>
                          </div>
                </div>
         </div>    
      </div>
</template>

<script>
import OkModal from '../../modals/OkModal';
import EventBus from '../../../static/js/event-bus';

export default {
    name: 'ApplicationSettings',
    data(){
        return {
            showToolTip: false,
            
            application: {
                generateChecked: false,
                logo: {
                   image:'/assets/logodefault.png'
                } 
            }
        }
    },
    methods: {
        addLogo(event){
            
        // in case uploaded file is jpg or png else alert error
        if (this.isFileImage(event.target.files[0])) {
             
            console.log(event.target.files[0])
            const fd = new FormData()
            // add image selected in the event and his name to the FormData object
            fd.append('image', event.target.files[0], event.target.files[0].name)
            this.update(this.apiPrefix, this.miscApiUrl + 'update-app-logo/', '', fd)
                .then( resp => {
                    this.getApplicationDetails();
                    // event-bus for refreshing CmsNavbar.vue component in App.vue after updating logo
                    EventBus.$emit('REFRESH_CMS_NAVBAR', resp.data.image);
                }).catch(err => {
                console.log(err.response)
            })
        }
        else {
          this.$modal.show(OkModal, {
              text: this.$t('message.provideCorrectFormat'),
              modalClass: this.modalClasses.okErrorClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
         }
        },
         getApplicationDetails(){
            this.get(this.apiPrefix, this.miscApiUrl, 'get-application-details/')
                .then(resp => {
                this.application = resp.data
                
                if(this.application.logo === null)
                    this.application.logo = {  
                                            image: '/assets/logodefault.png'
                    }
            })
            .catch(err => {
                console.log(err)
            })
        },
        updateApplicationDetails(){
          //   console.log(this.application)
             this.update(this.apiPrefix, this.miscApiUrl + 'update-application-details/', '', this.application)
                .then(() => {
                    // event-bus for updating tab title in App.vue component
                    EventBus.$emit('UPDATE_TAB_TEXT', this.application.tab_text);
                    this.$modal.show(OkModal, {
                        text: this.$t('message.appDetailsUpdated'),
                        modalClass: this.modalClasses.okSuccessClass
                    },
                    {
                        width: this.modalWidth(),
                        height: 'auto'
                    })
                    
                })
                .catch(err => {
                    console.log(err)
                })
        },
        getApplicationLogo(logo){
            console.log(logo)
        }
        
    },
    created(){
        this.getApplicationDetails()
    }
}

</script>

<style scoped>
  
  div.gallery {
        margin: 0 auto;
        border: 1px solid rgb(214, 214, 214);
        padding: 5px;
        border-radius: 4px;
        float: left;
        width: 180px;
        height: 180px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    div.gallery:hover {
        box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
    }

    div.gallery img {
        margin: 4%;
        width: 92%;
        height: auto;
    }

     .image-wrapper {
        height: 100%;
        width: 100%;
    }

    .tooltiptextlogo {
        visibility: hidden;
        width: 120px;
        height: 100%;
        background-color: #000;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0; 
        position: relative;
        left: -5%;
    }

    .tooltiptextvisible {
        visibility: visible;
        z-index: 1;
    }

   
</style>